import React from 'react';
import { useApp } from '../../context/AppContext';
import './LangToggle.css';

const LangToggle: React.FC = () => {
  const { lang, setLang } = useApp();

  return (
    <div className="lang-toggle" role="group" aria-label="Language">
      <button
        className={`lang-toggle__btn ${lang === 'es' ? 'active' : ''}`}
        onClick={() => setLang('es')}
      >
        ES
      </button>
      <span className="lang-toggle__divider">|</span>
      <button
        className={`lang-toggle__btn ${lang === 'en' ? 'active' : ''}`}
        onClick={() => setLang('en')}
      >
        EN
      </button>
    </div>
  );
};

export default LangToggle;
